import Sidebar from "../components/Sidebar/Sidebar";
import Header from "../components/Header/Header";
import AuthProvider from "../providers/AuthProvider";

function Layout() {
  return (
    <AuthProvider>
      <Header/>
      <Sidebar />
    </AuthProvider>
  );
}

export default Layout;
